import { MerchantIdentifier } from "../../enum/merchants";

export const merchantIdentifierToName = (merchantIdentifier: MerchantIdentifier) => {
    switch (merchantIdentifier) {
        case MerchantIdentifier.DigIn:
            return 'DIGin';
        default: return MerchantIdentifier[merchantIdentifier].replace(
            /([A-Z])/g,
            " $1"
        ).slice(1);
    }
}